// src/components/PrimaryPlaceSelector.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePlaces } from '../context/PlaceContext';
import SearchBar from './SearchBar';

/**
 * sanitizeQuotes(str)
 * Replaces curly quotes/apostrophes (" " ' ') with normal ones.
 */
function sanitizeQuotes(str) {
  if (!str) return str;
  return str
    .replace(/[''`′]/g, "'")
    .replace(/[""]/g, '"');
}

const PrimaryPlaceSelector = () => {
  const navigate = useNavigate();
  const { handlePlaceSelected } = usePlaces();
  const [primarySearchInput, setPrimarySearchInput] = useState('');

  const onPlaceSelectedFromSearch = async (rawPlaceDetails) => {
    // Clear search box text
    setPrimarySearchInput('');

    // 1) Sanitize place name/address
    const safeName = sanitizeQuotes(rawPlaceDetails.name);
    const safeAddress = sanitizeQuotes(rawPlaceDetails.address);

    const placeDetails = {
      ...rawPlaceDetails,
      name: safeName,
      address: safeAddress,
    };

    // 2) Call handlePlaceSelected from context
    const updated = await handlePlaceSelected(placeDetails, true);

    // 3) If slug returned, navigate immediately with encodeURIComponent
    if (updated?.slug) {
      console.log('[PrimaryPlaceSelector] Navigating to /p/', updated.slug);
      navigate(`/p/${encodeURIComponent(updated.slug)}`);
    }
  };

  return (
    <div>
      <SearchBar
        onPlaceSelected={onPlaceSelectedFromSearch}
        value={primarySearchInput}
        onChange={(e) => setPrimarySearchInput(e.target.value)}
        placeholder="Search for a place"
      />
    </div>
  );
};

export default PrimaryPlaceSelector;